import React from "react";
import { connect } from "react-redux";

import { getFatalError } from "state/app/selectors";
import { reload } from "state/app/actions";

import ErrorDetailsModal from "components/app/error/ErrorDetailsModal";
import "./FatalErrorReporter.css";

/**
 * The "Oops, something went wrong" reporter for the app
 */
class FatalErrorReporterModal extends React.Component {

  state = {
    isDetailsModalOpen: true
  }

  render() {
    if( this.props.fatalError !== null ) {
      return (
          <div className="fatal-error-reporter">
            <ErrorDetailsModal isOpen={this.state.isDetailsModalOpen} error={this.props.fatalError}/>
          </div>
      );
    }
    return null;
  }
}

export default connect(
  state => ({
    fatalError: getFatalError(state)
  }),
  { reload }
)(FatalErrorReporterModal);



// WEBPACK FOOTER //
// ./src/components/app/error/FatalErrorReporter.js